import React, {useEffect, useState, useCallback} from 'react';
import { Col, Container, Row } from "reactstrap";
import { handlingCatchError } from "../../../Utils/ErrorHandling";

import { useNavigate, useLocation, Link } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Config } from '../../../Utils/Config';
import { apiCommonTrigger } from '../../../Utils/apiServicehelper';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AccountSuccess = (props) => {
    const search = useLocation().search;
    const token = new URLSearchParams(search).get('token');
    const navigate = useNavigate();
    const [isAccountActivated, setIsAccountActivated] = React.useState(0);
    const [isLoading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [snackClr, setSnackClr] = React.useState('');
    const [snackMsg, setSnackMsg] = React.useState('');
    useEffect(() => {
        if(isAccountActivated === 0){
            verifyToken();
        }
    }, []);
    
    // Activation key verification API
    const verifyToken = () =>{
        setLoading(true);
         let inputData={
          "SecureId":token}
           apiCommonTrigger("post",`${Config.API_URL}/account/activateuser`,inputData)
            .then((res) => {
                if (res.status === 200) {
                    if(res.data === "success"){
                        setLoading(false);
                        setIsAccountActivated(1);
                    }
                }

                else{
                    if (res.status === 400){
                        setLoading(false);
                        setIsAccountActivated(2);
                    }
                    setLoading(false);
                    handlingCatchError(res, navigate);
                 }
            })
            .catch(err => {
                handlingCatchError(err, navigate);
              })
    }

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };
    
    return (
        <div className='thank-you-page'>
            {isLoading ? (
                <div className="loader-wrap">
                <div className="default-page loading loading-center"></div>
                </div>
            ) : (
                ""
            )}
            <Container>
                <Row>
                    {isAccountActivated === 1 ?
                    <Col className='text-center'>
                        <div className='thank-u-center'>
                        <h2>Thank You!</h2>
                        <p>Your account was activated successfully! You can now log in with the username and password you provided when you signed up.</p>
                        <hr/>
                        <div className='support-msg'>
                        <p>Having trouble? <a href={Config.ContactUrl}>Contact us</a></p>
                        <Link to={'/signin'} className='market-btn'>Continue to Log in</Link>
                        </div>
                        </div>
                    </Col>:
                    isAccountActivated === 2 ?
                    <Col className='text-center'>
                        <div className='thank-u-center'>
                        <h2>Token Expired!</h2>
                        <p>Your activation key has been may expired or already activated. Please contact support for further assistance.</p>
                        <hr/>
                        <div className='support-msg'>
                        <p>Having trouble? <a href={Config.ContactUrl}>Contact us</a></p>
                        <Link to={"/"} className='market-btn'>Go to Home</Link>
                        </div>
                        </div>
                    </Col> :
                    <Col className='text-center'>
                        <p className='payment-process'>Please wait while we process your request...</p>
                    </Col>
                    }
                </Row>
            </Container>
            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={handleClose} severity={snackClr} sx={{ width: '100%' }}>
                    {snackMsg}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default AccountSuccess;